// Users router
export default [
  {
    path: 'users',
    name: 'users',
    redirect: 'users/index',
    component: () =>
      import(/* webpackChunkName: "users" */ '../views/users/Users.vue'),
    children: [
      {
        path: 'index',
        name: 'usersManagement',
        meta: {
          tabbable: true,
          tableKeys: ['users'],
          filterKeys: ['users'],
          formKeys: [],
          routePermissions: ['usersView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "usersIndex" */ '../views/users/UsersIndex.vue'
          ),
      },
      {
        path: ':userId',
        name: 'usersEdit',
        meta: {
          menuActiveRouteName: 'usersManagement',
          routePermissions: ['usersView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "usersIndex" */ '../views/users/UsersIndex.vue'
          ),
      },
    ],
  },
];
